export const en_lang = {
};
